import React from 'react'
import InteractiveButton from '../../../../components/InteractiveButton/InteractiveButton';
import IconPlus from '../../../../components/Icons/IconPlus/IconPlus';
import { useOverviewTopActions } from './hooks/useOverviewTopActions';

const OverviewTopActions: React.FC = () => {
  const { canCreateCycle, canCreateScreen, handleCreateCycle, handleCreateScreen } =
    useOverviewTopActions();

  return (
    <div className='c-overview-top-actions '>
      <div className="flex flex-col xsm:flex-row justify-end gap-2 pb-2">
        {canCreateCycle && (
          <InteractiveButton
            as="a"
            iconLeft={<IconPlus />}
            text="Add new cycle"
            onClick={handleCreateCycle}
            className="cursor-pointer"
          />
        )}
        {canCreateScreen && (
          <InteractiveButton
            as="a"
            iconLeft={<IconPlus />}
            text="Add screen"
            onClick={handleCreateScreen}
            className="cursor-pointer"
          />
        )}
      </div>
    </div>
  )
};

export default OverviewTopActions;
